import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { AccessGroupService } from './../access-group.service';
import { LmTsService } from '../learner-maps/lm-ts.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-fs-slideshow',
  templateUrl: './fs-slideshow.component.html',
  styleUrls: ['./fs-slideshow.component.scss']
})
export class FsSlideshowComponent implements OnInit, OnDestroy {

  sorted_item: any[] = [];
  allitem: any[] = [];
  public profiles: any;
  args: any;
  currentCard = new Subject();
  currentCard1: any;
  counter = 0;
  nextCard: string;
  previousCard: string;
  public allcolumns: any;
  menu_links: any;
  active_route = '';
  profile_slideshow = false;
  userName = '';
  lm_card_view = false;
  learner_map: any;
  loading = false;
  @Input() learnerMapId: string;
  columns: any;

  private destroy$ = new Subject<void>();
  private lmDataLoaded = false;

  constructor(
    public lmda_service: LambdaFunctionService,
    public accessgroup: AccessGroupService,
    public lm_ts: LmTsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public store: Store<any>,
    private http: HttpClient
  ) {}

  ngOnDestroy() {
    this.allcolumns = [];
    this.lmda_service.lambda_res.next([]);
    localStorage.removeItem('fs_reveal_lm_id');
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.userName = localStorage.getItem('first_name') || '';
    this.loading = true;

    if (this.router.url.includes('profile-slideshow')) {
      this.profile_slideshow = true;
      this.store.select<any>((state) => state.profile.accessGroupData).pipe(
      takeUntil(this.destroy$),
      filter(message => !!message)
    ).subscribe(message => {
      this.menu_links = message;
      if(this.menu_links?.main_menu?.profile?.profile_slideshow?.value) {
        this.loadLearnerMapById(this.menu_links?.main_menu?.profile?.profile_slideshow?.value);
      }
    })
    } else if (this.router.url.includes('challenge-navigator-print-coach')) {
      this.lm_card_view = true;
      this.loadLearnerMapById(this.learnerMapId || '36');
    } else if (this.router.url.includes('challenge-navigator-print')) {
      this.lm_card_view = true;
      this.loadLearnerMapById('36');
    } else if (this.learnerMapId && !this.router.url.includes('fs-reveal')) {
      this.lm_card_view = true;
      this.loading = false;
      localStorage.setItem('fs_reveal_lm_id', this.learnerMapId);
    } else {
      this.loadFsRevealRoute();
    }

    if (!this.learnerMapId) {
      this.setupSlideNavigation();
    }
  }

  private loadFsRevealRoute() {
    this.store.select<any>((state) => state.profile.accessGroupData).pipe(
      takeUntil(this.destroy$),
      filter(message => !!message)
    ).subscribe(message => {
      this.menu_links = message;

      this.activatedRoute.params.pipe(
        takeUntil(this.destroy$)
      ).subscribe((params: Params) => {
        this.active_route = params.id;
        const presentationTitle = this.menu_links['main_menu']?.dynamic_lms?.presentation?.title;

        if (presentationTitle?.toLowerCase() === params?.id) {
          this.lm_card_view = false;
          if(this.menu_links['main_menu']?.dynamic_lms?.presentation?.value) {
            this.loadLearnerMapById(this.menu_links['main_menu']?.dynamic_lms?.presentation?.value);
          }
        } else if (params?.id === 'presenter-lm') {
          this.loadPresenterLm();
        }
      });
    });
  }

  private loadPresenterLm() {
    if (this.lmDataLoaded) return;

    const presenterValue = this.menu_links['main_menu']?.dynamic_lms?.presenter_lm?.value;
    if (!presenterValue) return;

    this.lmDataLoaded = true;

    this.http.get(`${environment.profileURL}/api/v1/learner_maps/${presenterValue}`).pipe(
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.sorted_item = res.learner_map?.learner_map_columns?.sort((a, b) => a?.position - b?.position) || [];
      this.lmda_service.lambda_res.next(res.learner_map?.learner_map_columns);
      localStorage.setItem('fs_reveal_lm_id', presenterValue);
      this.lm_card_view = true;
      this.loading = false;
    });
  }

  private setupSlideNavigation() {
    this.lm_ts.an_slide_no.pipe(
      takeUntil(this.destroy$)
    ).subscribe(val => {
      this.counter = val;
      this.currentCard.next(this.sorted_item[this.counter]);
    });

    this.currentCard.pipe(
      takeUntil(this.destroy$)
    ).subscribe(val => {
      this.currentCard1 = val;
    });
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  private loadLearnerMapById(lmId: string) {
    this.allitem = [];
    this.sorted_item = [];
    this.lmda_service.lambda_res.next([]);

    this.http.get(`${environment.profileURL}/api/v1/learner_maps/${lmId}`).pipe(
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.lmda_service.lambda_res.next(res.learner_map?.learner_map_columns);
    });

    this.lmda_service.lambda_res.pipe(
      takeUntil(this.destroy$)
    ).subscribe(allCards => {
      if (!allCards || !Array.isArray(allCards) || allCards.length === 0) return;

      this.lm_ts.an_slide_no.next(0);
      this.allitem = [];

      if (this.router.url.includes('challenge-navigator-print')) {
        this.columns = allCards;
      }

      allCards.forEach((col: any) => {
        const cards = col['learner_map_cards'] || col['cards'] || [];
        cards.forEach((card: any) => {
          this.allitem.push(card);
        });
      });

      const sorting = [];
      this.allitem.forEach(element => {
        const idx = parseInt(element.order || element.position) - 1;
        if (!isNaN(idx)) sorting[idx] = element;
      });

      this.sorted_item = sorting.filter(el => el?.active !== false && el?.active?.BOOL !== false);
      this.allcolumns = this.sorted_item;
      this.currentCard.next(this.sorted_item[this.counter]);
      this.loading = false;
    });
  }

  printSlides() {
    const params = this.activatedRoute.snapshot.params;
    document.title = params.id || (this.profile_slideshow ? 'Profile Slideshow' : 'Slides');
    window.print();
    document.title = 'App | FourSight';
  }
}
